import React from 'react';
export default class ErrorBoundary extends React.Component {
  state = { failed:false };
  static getDerivedStateFromError() { return {failed:true}; }
  render() { if(this.state.failed)return <main className="onboarding"><section className="panel onboarding-panel"><h1>화면을 다시 불러와 주세요</h1><p className="muted">업무 데이터를 표시하는 중 문제가 발생했습니다. 저장된 업무는 다시 로그인해 확인할 수 있습니다.</p><button className="button primary" onClick={()=>window.location.reload()}>다시 불러오기</button></section></main>;return this.props.children; }
}
